import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsAccordion from 'components/blocks/LandingsAccordion/LandingsAccordion'
import {Col, Container, Row} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'

import s from './InvoiceFaq.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceFaqProps {
	className?: string
	content: IInvoiceContent['faq']
}

/** InvoiceFaq block component */
const InvoiceFaq: FC<IInvoiceFaqProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col>
						<LandingsAccordion items={content?.items} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceFaq.displayName = 'InvoiceFaq'

export default InvoiceFaq
